// extracted by mini-css-extract-plugin
export default {"header":"Header_header__LmGEN","logo":"Header_logo__sxot8","content_holder":"Header_content_holder__J+lFp","link_holder":"Header_link_holder__W3z1o"};